import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getOrderDataById, orderEasyUpdate } from '../../../../services/clinicPortalServices/orderEditService';
import { Autocomplete, TextField } from '@mui/material';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { individualTestStatuses, orderStatuses } from '../../../../services/common/optionsData';
import toastr from 'toastr';

export default class OrderStatusPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderDetails: null,
            status: '',
            cancelReason: '',
            isSaving: false
        };
    }

    componentDidMount() {}

    componentDidUpdate(prevProps) {
        if (this.props.show && this.props.show !== prevProps.show) {
            getOrderDataById(this.props.data._id).then((res) => {
                this.setState({
                    orderDetails: res.data,
                    status: res.data.status,
                    cancelReason: res.data.cancel_reason || ''
                });
            });
        }
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSave = () => {
        const isCancelled = this.state.status === 'Cancelled';
        const cancelReason = (this.state.cancelReason || '').trim();
        if (isCancelled && !cancelReason) {
            toastr.warning('Reason for Cancellation is required when status is Cancelled.');
            return;
        }

        let params = {
            _id: this.state.orderDetails._id,
            status: this.state.status,
            is_cancel: isCancelled,
            cancel_reason: isCancelled ? cancelReason : ''
        };
        this.setState({ isSaving: true });
        orderEasyUpdate(params)
            .then((response) => {
                this.props.context.componentParent.loadGridData();
                this.props.handleClose();
                toastr.success('Order status updated successfully.');
            })
            .catch((error) => {
                toastr.error('Failed to update order status. Please try again.');
            })
            .finally(() => {
                this.setState({ isSaving: false });
            });
    };

    render() {
        return (
            <ModalStyled
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.props.show}
                onHide={this.props.handleClose}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Order Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.orderDetails && (
                        <div className="row">
                            <div className="col-12">Current Status: {this.state.orderDetails.status}</div>
                            <div className="col-12 mt-4">
                                <Autocomplete
                                    options={
                                        this.state.orderDetails.order_type === 'root'
                                            ? orderStatuses
                                            : individualTestStatuses
                                    }
                                    value={this.state.status}
                                    onChange={(event, newValue) => {
                                        this.setState({
                                            status: newValue
                                        });
                                    }}
                                    getOptionLabel={(option) => (option ? option : '')}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="outlined" label="Status *" />
                                    )}
                                />
                            </div>
                            {this.state.status === 'Cancelled' && (
                                <div className="col-12 mt-4">
                                    <TextField
                                        label="Reason for Cancellation *"
                                        variant="outlined"
                                        fullWidth
                                        multiline
                                        minRows={3}
                                        value={this.state.cancelReason}
                                        onChange={(e) => {
                                            const value = e.target.value || '';
                                            if (value.length <= 1000) {
                                                this.setState({ cancelReason: value });
                                            }
                                        }}
                                        helperText={`${(this.state.cancelReason || '').length}/1000`}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.props.handleClose} disabled={this.state.isSaving}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={this.handleSave}
                        disabled={this.state.isSaving || (this.state.status !== this.props.data.status ? false : true)}
                    >
                        {this.state.isSaving ? 'Updating...' : 'Save'}
                    </Button>
                </Modal.Footer>
            </ModalStyled>
        );
    }
}
